export const GET_LEADOM_CONFIG_REQUEST = 'GET_LEADOM_CONFIG_REQUEST';
export const GET_LEADOM_CONFIG_REQUEST_SUCCESS = 'GET_LEADOM_CONFIG_REQUEST_SUCCESS';
export const GET_LEADOM_CONFIG_REQUEST_FAILURE = 'GET_LEADOM_CONFIG_REQUEST_FAILURE';

export const CHANGE_LEADOM_CONFIG_REQUEST = 'CHANGE_LEADOM_CONFIG_REQUEST';
export const CHANGE_LEADOM_CONFIG_REQUEST_SUCCESS = 'CHANGE_LEADOM_CONFIG_REQUEST_SUCCESS';
export const CHANGE_LEADOM_CONFIG_REQUEST_FAILURE = 'CHANGE_LEADOM_CONFIG_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/redux/constants/leadom_config.constants.js